import React, { useState, useEffect } from "react";
import ClientForm from "../../Components/Client/ClientForm";
import {
  findClientBySocieteApi,
  findNiveauxFidelite,
} from "../../_App/Redux/Slices/client/clientSlice";
import { societeId } from "../../_App/Redux/Slices/Auth/authSlice";
import { useAppDispatch, useAppSelector } from "../../_App/Redux/hooks";

import { useTranslation } from "react-i18next";
import Navbar from "../../_Layouts/Navbar/Navbar";
import Swal from "sweetalert2";
import ChequesPage from "../Caisses/ChequesPage";
import VirementsPage from "../Caisses/VirementsPage";
import BonsPAge from "../Caisses/BonsPage";

const ReglementsPage = () => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState("Chéques");

  return (
    <div>
      <Navbar titre={"Réglements"} />

      <div
        className="container"
        style={{ margin: 0, width: "100%", maxWidth: "none" }}
      >
        <div className="btn-group mb-4" style={{ width: "100%" }}>
          <button
            className={`btn ${
              activeTab === "Chéques" ? "btn-primary" : "btn-outline-primary"
            }`}
            onClick={() => setActiveTab("Chéques")}
          >
            {t("Chéques")}
          </button>
          <button
            className={`btn ${
              activeTab === "Virements" ? "btn-primary" : "btn-outline-primary"
            }`}
            onClick={() => setActiveTab("Virements")}
          >
            {t("Virements")}
          </button>
          <button
            className={`btn ${
              activeTab === "Bons" ? "btn-primary" : "btn-outline-primary"
            }`}
            onClick={() => setActiveTab("Bons")}
          >
            {t("Bons")}
          </button>
          <button
            className={`btn ${
              activeTab === "categorie" ? "btn-primary" : "btn-outline-primary"
            }`}
            onClick={() => setActiveTab("Tickets cadeaux")}
          >
            {t("Tickets cadeaux")}
          </button>
        </div>

        {/* Client Tab */}
        {activeTab === "Chéques" && <ChequesPage />}
        {activeTab === "Virements" && <VirementsPage />}
        {activeTab === "Bons" && <BonsPAge />}
      </div>
    </div>
  );
};

export default ReglementsPage;
